import React from 'react';
import BeaconChartWithLegend from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconChartWithLegend';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import RatingsSummaryKeyMetricsCards from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSummary/ReviewSummaryKeyMetricsCards';
import ReviewSummaryProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSummary/ReviewSummaryProductGrid';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import {
  BEACON_CHART_SPACING,
  BEACON_KEY_METRIC_CARD_SPACING
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import {
  refineSubtitle,
  useEntityPhrasing,
  useTaxonomySubtitleText
} from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import { useReviewCumulativeValues } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewsHooks';
import NoDataPlaceHolder, {
  NoDataIcon
} from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import { NewBeaconFileIcon } from 'src/components/SvgIcons';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';

export const EntityNoDataPlaceHolder = (
  <Flex marginTop="71px" alignItems="center" justifyContent="center">
    <NoDataPlaceHolder
      title="Data currently unavailable"
      description="There is currently no data matching your selected criteria. Please try another query to view insights."
      icon={<NoDataIcon icon={<NewBeaconFileIcon />} />}
    />
  </Flex>
);

/**
 * Review tab, Summary page
 */
const ReviewSummaryPage = () => {
  const entityPhrase = useEntityPhrasing();
  const taxonomyText = useTaxonomySubtitleText();

  const { isProductEntity } = useProductEntity();
  // check if this entity has any review / rating data
  const { reviewCumulativeCountData, reviewCumulativeCountLoading } = useReviewCumulativeValues({
    aggregationFieldNames: ['lifetimeReviewVolume', 'childLifetimeRatingVolume']
  });

  const subtitle = refineSubtitle([entityPhrase, taxonomyText]);

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {!reviewCumulativeCountLoading && reviewCumulativeCountData?.length === 0 ? (
          EntityNoDataPlaceHolder
        ) : (
          <>
            <Flex flexDirection="column" gap={BEACON_KEY_METRIC_CARD_SPACING}>
              <BeaconChartWithLegend
                title="Key Metrics"
                showExportMenu={false}
                includeSummaryInfo={false}
                subtitle={
                  <BeaconSubtitleContainer>
                    <Text variant="body1">
                      {`The metrics display the ratings and reviews summary for `}
                      {subtitle}.
                      <SubtitleFilters />
                    </Text>
                  </BeaconSubtitleContainer>
                }
              >
                <RatingsSummaryKeyMetricsCards />
              </BeaconChartWithLegend>
            </Flex>

            <ReviewSummaryProductGrid
              disableGroupBy
              metric={isProductEntity ? undefined : 'summary'}
              tableComponent={isProductEntity ? 'review' : 'product'}
            />
          </>
        )}
      </Flex>
    </BasePageContainer>
  );
};

export default ReviewSummaryPage;
